import {Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps} from '@mui/material'
import {CSSProperties, FC} from 'react'
import './styles.scss'
import {Checked} from './img/icons'

export type CheckboxProps = {
  checkedIconStyle?: CSSProperties,
  checkboxIconStyle?: CSSProperties
  indeterminateIconStyle?: CSSProperties
} & MuiCheckboxProps

export const Checkbox: FC<CheckboxProps> = ({
  checkedIconStyle,
  checkboxIconStyle,
  indeterminateIconStyle,
  ...rest
}) => {
  return (
    <MuiCheckbox
      classes={{root: 'override-checkbox-root'}}
      icon={<span style={checkboxIconStyle} className='override-checkbox-icon'></span>}
      checkedIcon={
        <span style={checkedIconStyle} className='override-checkbox-checkedIcon'>
          {<Checked />}
        </span>
      }
      indeterminateIcon={<span style={indeterminateIconStyle} className='override-checkbox-indeterminateIcon'><span></span></span>}
      {...rest}
    />
  )
}
